import axios from "axios";
import { history } from "./useHistory";
import { API_BASE_URL } from "./apiBaseUrl";

const USER_STORAGE_KEY = "user_soquo";
const PERSIST_STORAGE_KEY = "persist:root";

let refreshPromise = null;

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_STORAGE_KEY));
  } catch (error) {
    return null;
  }
};

export const setStoredUser = (user) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const clearStoredSession = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem(PERSIST_STORAGE_KEY);
};

export const redirectToLogin = () => {
  if (history.location.pathname !== "/login") {
    history.push("/login");
  }
};

const refreshAccessToken = async () => {
  const response = await axios.post(
    `${API_BASE_URL}/v1/auth/refresh`,
    {},
    { withCredentials: true }
  );
  const user = response?.data?.data;
  if (!user?.token) {
    throw new Error("Refresh token response tidak valid");
  }
  setStoredUser(user);
  return user.token;
};

export const configureAuthInterceptors = (instance) => {
  instance.defaults.withCredentials = true;

  instance.interceptors.request.use((config) => {
    const user = getStoredUser();
    const token = user?.token;
    config.headers = config.headers || {};

    if (token) {
      config.headers["x-auth-token"] = token;
    } else {
      delete config.headers["x-auth-token"];
    }

    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error?.config;
      const status = error?.response?.status;
      const url = originalRequest?.url || "";
      const isAuthRequest =
        url.includes("/v1/auth/login") ||
        url.includes("/v1/auth/refresh") ||
        url.includes("/v1/auth/logout");

      if (
        status !== 401 ||
        !originalRequest ||
        originalRequest._retry ||
        isAuthRequest
      ) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        if (!refreshPromise) {
          refreshPromise = refreshAccessToken().finally(() => {
            refreshPromise = null;
          });
        }

        const token = await refreshPromise;
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers["x-auth-token"] = token;
        return instance(originalRequest);
      } catch (refreshError) {
        clearStoredSession();
        redirectToLogin();
        return Promise.reject(refreshError);
      }
    }
  );

  return instance;
};
